<template>
  <v-card-text>
    <v-text-field outlined dense single-line v-model="title"> </v-text-field>
  </v-card-text>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "DemoComp2",
  props: {
    value: {
      default: null,
    },
  },
})
export default class DemoComp2 extends Vue {
  title = "Demo Comp-2 default";

  @Watch("title")
  async onValueChange(val) {
    this.$root.$emit("event.expenses.add", val);
  }
}
</script>
